import React from "react";
interface props {
  className?: string;
  icon?: React.ReactNode;
  indexNo?: string;
  title?: string;
  titleClass?: string;
  iconClass?: string;
  textContent?: string;
  imageLink?: string;
}

export const WhyABCard = ({
  className,
  icon,
  indexNo,
  title,
  titleClass,
  iconClass,
  textContent,
  imageLink,
}: props) => {
  return (
    <div
      className={` ${className} w-[285px] h-[340px] lg:w-[685px] lg:h-[438px] flex-col flex flex-shrink-0 mr-[50px] lg:mr-[111px]`}
    >
      <div className="flex relative">
        <p className="font-openSans font-semibold text-[20px] lg:text-[32px] leading-7 lg:leading-[46px] text-[#717272] text-opacity-40">
          {indexNo}
        </p>
        <div className="relative">
          <p
            className={`font-openSans font-normal text-[20px] lg:text-[32px] leading-7 lg:leading-[46px] text-brand-textBlack ml-2 lg:ml-[18px] ${titleClass}`}
          >
            {title}
          </p>

          <div className={` ${iconClass} `}>{icon}</div>
        </div>
      </div>
      <div className="flex flex-col lg:flex-row  w-full lg:mt-auto">
        <img
          src={imageLink}
          className="mt-8 lg:mt-auto max-w-[157px]  max-h-[145px] lg:max-h-[273px] lg:max-w-[297px] h-full w-full"
          alt=""
        />
        <p className="mt-2 lg:mt-auto  lg:ml-6 w-full  font-openSans font-normal text-mobile-body-sm lg:text-web-body-lg leading-5 lg:leading-[22px] text-brand-textGrey">
          {textContent}
        </p>
      </div>
    </div>
  );
};
